import { CHAT_MESSAGE_FAILED_REASONS, CHAT_MESSAGE_STATUSES } from 'cpool-constants';

import type { ChatMessage } from '~/features/whatsapp/types/message';

// Latest non-queued message decides — anything but a SENDER_NUMBER_UNAVAILABLE failure clears it.
export const isSenderNumberUnavailable = (messages: Array<Pick<ChatMessage, 'failureReason' | 'status'>>): boolean => {
    const latestSettled = [...messages].reverse().find((message) => message.status !== CHAT_MESSAGE_STATUSES.QUEUED);
    return (
        latestSettled?.status === CHAT_MESSAGE_STATUSES.FAILED &&
        latestSettled.failureReason === CHAT_MESSAGE_FAILED_REASONS.SENDER_NUMBER_UNAVAILABLE
    );
};
